export default __webpack_public_path__ + "static/media/sumit.8a58a0d1.png";